<script>
import api from '@/command/api'
import TemplateHeaderTable from '@/components/TemplateHeaderTable'
import moment from 'moment'
import { getAction } from '@/command/netTool'

export default {
  name: 'partyBuilding',
  data() {
    return {
      ...api.command.getState(),
      paramsValue: {},
      partyBuildingTypeList: [],
    }
  },
  mounted() {
    getAction('/base/farmPartyBuilding/getTypeList').then((res) => {
      if (res.code != 200) return
      this.partyBuildingTypeList = (res.data || []).map((item) => {
        return {
          name: item.name,
          value: item.id,
        }
      })
    })
    api.command.getList.call(this, {
      url: '/base/farmPartyBuilding/page',
      current: 1,
    })
  },
  methods: {
    getHeader() {
      return [
        {
          name: '政策标题',
          type: 'input',
          key: 'title',
          placeholder: '请输入政策标题',
        },
        {
          name: '政策类型',
          type: 'select',
          key: 'partyBuildingTypeId',
          placeholder: '请选择政策类型',
          typeData: this.partyBuildingTypeList,
        },
        // {
        //   name: '发布时间',
        //   type: 'rangePicker',
        //   placeholder: '请选择发布时间',
        //   keys: ['dateGe', 'dateLe'],
        // },
      ]
    },
    getColumns() {
      return [
        {
          dataIndex: 'title',
          title: '政策标题',
          align: 'left',
        },
        {
          title: '政策类型',
          dataIndex: 'partyBuildingTypeName',
          align: 'left',
        },
        {
          dataIndex: 'upDown',
          title: '状态',
          type: 'badge',
          onExport: (records) => {
            return ['上架', '下架'][records]
          },
          render(data) {
            return {
              showDot: true,
              name: data == 0 ? '上架' : '下架',
              color: data == 0 ? 'green' : 'red',
            }
          },
        },
        {
          dataIndex: 'createTime',
          title: '发布日期',
          align: 'left',
        },
        {
          dataIndex: 'action',
          title: '操作',
          type: 'buttonGroup',
          align: 'center',
          typeData: ({ records }) => {
            return [
              {
                name: records.upDown == 0 ? '下架' : '上架',
                onClick: () => {
                  api.command.editGET.call(this, {
                    url: `/base/farmPartyBuilding/${records.upDown == 1 ? 'up' : 'down'}?id=${records.id}`,
                  })
                },
              },
              {
                name: '编辑',
                onClick: () => this.$router.push(`/policyManagement/detail?id=${records.id}`),
              },
              {
                name: '删除',
                type: 'pop',
                popTitle: '确认删除吗?',
                onClick: () =>
                  api.command.del.call(this, {
                    url: `/base/farmPartyBuilding?id=${records.id}`,
                  }),
              },
            ]
          },
        },
      ]
    },
    getButton() {
      return [
        {
          name: '添加',
          icon: 'plus',
          type: 'primary',
          onClick: () => this.$router.push('/policyManagement/detail'),
        },
        {
          viewType: 'menu',
          name: '更多操作',
          isBatch: true,
          children: [
            {
              name: '批量删除',
              onClick: (data) => {
                let idList = data.map((e) => e.id)
                return api.command.delPut.call(this, {
                  url: `/base/farmPartyBuilding/deleteBatch`,
                  params: { idList },
                })
              },
            },
          ],
        },
      ]
    },
  },
  render() {
    return (
      <TemplateHeaderTable
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        button={this.getButton()}
        records={this.records}
      />
    )
  },
}
</script>
